import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressBookComponent } from './address-book.component';
import { RouterModule } from '@angular/router';
import { AddressBookController } from 'src/app/core/controllers/address-book.controller';
import { ListService } from 'src/app/core/lib/list.service';
import { CtDatatableModule, CtSearchFiltersModule, DeleteConfirmService } from '@ctsolution/ct-framework';
import { MatLegacyCardModule } from "@angular/material/legacy-card";
import { MatLegacyButtonModule } from "@angular/material/legacy-button";
import { AddressBookDetailModule } from './address-book-detail/address-book-detail.module';
import { AddressBookService } from './address-book.service';
import { AddressBookContactComponent } from './address-book-contact/address-book-contact.component';
import { AddressBookContactModule } from './address-book-contact/address-book-contact.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    CtSearchFiltersModule,
    MatLegacyCardModule,
    CtDatatableModule,
    MatLegacyButtonModule,
    AddressBookDetailModule,
    AddressBookContactModule,
    MatIconModule,
    RouterModule
      .forChild([
        {
          path: "gestione-rubriche",
          component: AddressBookContactComponent,
          data: {
            title: "Gestione rubriche",
            description: "Modifica e visualizza le tue rubriche",
          }
        },
        {
          path: "",
          component: AddressBookComponent,
          data: {
            title: "Rubriche",
            description: "Visualizza e gestisci le tue rubriche",
            urls: [{ title: "Rubriche", url: "/amministrazione/rubrica" }, { title: "Rubriche" }]
          }
        }
      ])
  ],
  declarations: [AddressBookComponent],
  exports: [AddressBookComponent],
  providers: [AddressBookController, ListService, DeleteConfirmService,AddressBookService]
})
export class AddressBookModule { }
